import classNames from 'classnames';
import parse from 'html-react-parser';

import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

import { TLibraryNews } from '../../../types/TGetLibraryNewsResponse';

import placeholderImage from '../../../images/placeholder.jpg';

import commons from '../../../shared/styles/common.module.scss';
import styles from './LibraryNewsItem.module.scss';

type TProps = {
  libraryNewsItem: TLibraryNews;
};

const LibraryNewsItem = ({ libraryNewsItem }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div
      className={classNames(
        styles.libraryNewsItemContainer,
        commons.container,
      )}>
      <div className={styles.libraryNewsItemContent}>
        <a
          key={libraryNewsItem.id}
          href={String(libraryNewsItem.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(
              libraryNewsItem.id,
              'libraryNewsPage',
              ':libraryNewsId',
            );
          }}
          className={styles.libraryNewsItemWrapper}>
          <div className={styles.libraryNewsItemText}>
            <h4 className={styles.libraryNewsItemTitle}>
              {libraryNewsItem.title}
            </h4>
            <p className={styles.libraryNewsItemExcerpt}>
              {parse(libraryNewsItem.excerpt)}
            </p>
          </div>
          <img
            src={libraryNewsItem.featured_image || placeholderImage}
            alt={libraryNewsItem.title}
            className={styles.libraryNewsItemImage}
          />
        </a>
      </div>
    </div>
  );
};

export default LibraryNewsItem;
